import { FaExclamationTriangle, FaExternalLinkAlt, FaInfoCircle, FaSave } from "react-icons/fa"
import { BACKEND } from "../../config/configEnvs"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import axios from "axios"
import Tooltip from "../ui/ToolTip";

const TareaAdministracion = ({register, handleAdminTaskStatusChange, formatDate, handleUpdateWorkerNotesAdminTask}) => {

  const [workerNotes, setWorkerNotes] = useState(register.workerNotes)

  const storeTaskWorkedOnLocalStorage = (newTaskId) => { // Guardar la tarea trabajada en el local storage para el reporte del día

    // Extraemos el array del local storage, si no existe lo inicializamos
    let tasksWorked = JSON.parse(localStorage.getItem("adminTasksWorked")) || [];

    // Verificamos si la tarea ya existe en el array
    const existingTask = tasksWorked.find((existingTask) => existingTask.task === newTaskId);

    if (existingTask) {
        return; // Si ya existe, no hacemos nada
    }
    const newTaskWorked = { task: newTaskId }; // Creamos un objeto con la nueva tarea
    tasksWorked.push(newTaskWorked); // Agregamos la nueva tarea al array
    localStorage.setItem("adminTasksWorked", JSON.stringify(tasksWorked)); // Guardamos el array actualizado en el local storage
  };

  const handleSaveWorkerNotes = async () => { // Guardar las notas del trabajador en la tarea
    try {
      const response = await axios.put(`${BACKEND}/api/tareasAdministracion/${register.id}`, {
        workerNotes: workerNotes
      })
      if (response.status === 200) {
        handleUpdateWorkerNotesAdminTask(register.id, workerNotes)
      }
    } catch (error) {
      toast.error("Error al guardar el texto")
    }
  }

  useEffect(() => {
    setWorkerNotes(register.workerNotes);
  }, [register.workerNotes]); // Se ejecutará cuando register.workerNotes cambie

  return (
    <div className="flex flex-col p-2 gap-1 border border-gray-300 rounded-sm bg-white hover:bg-gray-100 hover:shadow transition-all duration-100">
      <div className="flex flex-row justify-between">
        <span className="text-xs px-1"><span className="font-bold">Tarea: </span> {register.task}</span>

        {register.status === "Declinado" && (
          <Tooltip content={`La tarea ha sido declinada por el administrador`}>
            <div className='hover:cursor-pointer'>
              <FaExclamationTriangle className="text-yellow-400"/>
            </div>
        </Tooltip>
        )}

        {register.status === "Incumplido" && (
          <Tooltip content={`La tarea no se completó`}>
            <div className='hover:cursor-pointer'>
              <FaInfoCircle className="text-red-500"/>
            </div>
        </Tooltip>
        )}
 
        
      </div>
      <span className="text-xs px-1"><span className="font-bold">Notas de administración: </span> {register.adminNotes}</span>
      <span className="text-xs px-1"><span className="font-bold">Fecha límite: </span> {formatDate(register.limitDate)}</span>

      {register.status === "Finalizado" && (
        <span className="text-xs px-1"><span className="font-bold">Fecha entrega: </span> {formatDate(register.deliverDate)}</span>
      )}

      {/* Audios */}
      <div>
        {register.audios?.length > 0 ? (
          <>
            <span className="text-xs px-1 font-bold">Audios:</span>
            <ul className="list-disc">
              {register.audios.map((audio, index) => {
                return (
                  <div key={index} className="mb-2">

                    {audio.mimeType === 'audio/wav' && (
                      <div className="space-y-2 bg-gray-50 border border-gray-200 rounded-md p-2 shadow-sm text-xs">

                        <div className="flex items-center justify-between mb-1">
                          <span className="font-semibold text-gray-800">{audio.filename}</span>
                          <div className="flex space-x-2">
                            <button
                              type="button"
                              onClick={() => window.open(audio.url, '_blank')}
                              className="p-2 text-blue-500 hover:bg-blue-600 hover:bg-opacity-20 rounded-md transition duration-150"
                              title="Abrir en una nueva pestaña"
                            >
                              <FaExternalLinkAlt />
                            </button>
                          </div>
                        </div>

                        <audio controls className="w-full rounded-md bg-gray-100 text-xs h-4">
                          <source src={audio.url} type={audio.mimeType || 'audio/mpeg'} />
                          Tu navegador no soporta el elemento de audio.
                        </audio>
                      </div>
                    )}
                  </div>
                );
              })}
            </ul>
          </>
        ) : (
          null
        )}
      </div>

      {/* Links */}
      <div>
        {register.adminLinks?.length > 0 ? (
          <>
            <span className="text-xs px-1 font-bold">Links:</span>
            <ul className="list-disc">
              {register.adminLinks.map((link, index) => {
                return (
                  <div key={index} className="mb-2">
                    <input 
                      type="text" 
                      className="w-full border border-white rounded-l-lg text-xs px-2 py-1"
                      value={link.link} 
                    />
                  </div>
                );
              })}
            </ul>
          </>
        ) : (
          null
        )}
      </div>
      
      { /* Notas del trabajador */}
      <span className="text-xs px-1 font-bold">Notas del trabajador:</span>
      <div className="flex border rounded-lg">
        <input
            type="text"
            value={workerNotes}
            disabled={register.status === "Finalizado" || register.status === "Incumplido"}
            placeholder="Introduce una nota"
            onChange={(e) => setWorkerNotes(e.target.value)}
            className="w-full border border-white rounded-l-lg text-xs px-2 py-1"
        />
        <button
            type="button"
            disabled={register.status === "Finalizado" || register.status === "Incumplido"}
            onClick={() => handleSaveWorkerNotes()}
            className="inline-flex items-center px-3 text-sm text-black bg-gray-100 border border-gray-300 hover:bg-gray-200 rounded-r-md transition-all duration-100"
        >
            <FaSave />
        </button>
      </div>

      { /* Estado */}
      <span className="text-xs px-1 font-bold">Estado:</span>
      <select 
        value={register.status}
        onChange={(e) => {
          handleAdminTaskStatusChange(register.id, e.target.value)
          storeTaskWorkedOnLocalStorage(register.id)
        }}
        disabled={register.status === "Finalizado" || register.status === "Incumplido"}
        className="text-gray-700 bg-white border border-gray-200 rounded-lg shadow focus:outline-none w-full text-xs hover:cursor-pointer px-2 py-1"

      >
        <option value={"Por comenzar"}>Por comenzar</option>
        <option value={"En proceso"}>En proceso</option>
        <option value={"Finalizado"}>Finalizado</option>
        <option hidden value={"Declinado"}>Declinado</option>
        <option hidden value={"Incumplido"}>Incumplido</option>
      </select>

    </div>
  )
}

export default TareaAdministracion